import { useMyDataQuery } from "@/generated/graphql";

export const getHomeRouteForObjective = (objective?: string | null) => {
  return objective === "other_channels" ? "/community-library" : "/projects";
};

export const useHomeRoute = () => {
  const { data, loading } = useMyDataQuery();
  return {
    route: getHomeRouteForObjective(data?.myData?.onboarding_objective),
    loading,
  };
};
